import { useEffect, useRef } from "react";

const Pagination = ({
    startedPage = 1,
    pages,
    onPaginationChange
}) => {
    const paginationRef = useRef(null);

    const handlePaginationChange = (item) => {
        let page = item?.detail
        // alert(page)
        onPaginationChange({ page })
    }

    useEffect(() => {
        const { current } = paginationRef;

        current?.addEventListener('bdsPaginationChange', handlePaginationChange);

        return () => {
            current.removeEventListener('bdsPaginationChange', handlePaginationChange);
        };
    }, []);

    return (
        <>
            <bds-pagination
                ref={paginationRef}
                pages={pages}
                started-page={startedPage}
            />
        </>
    )
}

export default Pagination